<!-- START: pages/login-alpha -->
<div
  class="cat__pages__login cat__pages__login--fullscreen"
  style="background-image: url(assets/modules/pages/common/img/login/hero-dark.jpg)"
></div>
<!-- END: pages/login-alpha -->
